import { Component } from '@angular/core';

@Component({
  selector: 'app-rc-spinner',
  templateUrl: './rc-spinner.component.html',
  styleUrls: ['./rc-spinner.component.scss'],
})
export class RcSpinnerComponent {
  /**
   * Initializer
   */
}
